/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateCompiler, TranslateModule } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { ShellModule } from './shell/shell.module';
import { LoginModule } from './login/login.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HotelsModule } from '@app/hotels/hotels.module';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { SettingsModule } from '@app/settings/settings.module';
import { NgxUiLoaderHttpModule, NgxUiLoaderModule, POSITION, SPINNER } from 'ngx-ui-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SuppliersModule } from '@app/suppliers/suppliers.module';
import { EventsModule } from '@app/events/events.module';
import { ClientsModule } from '@app/clients/clients.module';
import { SalesModule } from '@app/sales/sales.module';
import { FinanceModule } from '@app/finance/finance.module';
import { RemindersModule } from '@app/reminders/reminders.module';
import { DashboardModule } from '@app/dashboard/dashboard.module';
import { ProfileModule } from '@app/profile/profile.module';
import { NotificationsModule } from '@app/notifications/notifications.module';
import { ReportsModule } from '@app/reports/reports.module';
import { BanksModule } from '@app/banks/banks.module';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { CampaignModule } from '@app/campaign/campaign.module';

@NgModule({
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.serviceWorker }),
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    }),
    NgbModule,
    CoreModule,
    SharedModule,
    ShellModule,
    DashboardModule,
    HotelsModule,
    LoginModule,
    SettingsModule,
    SuppliersModule,
    EventsModule,
    ClientsModule,
    ProfileModule,
    SalesModule,
    FinanceModule,
    RemindersModule,
    NotificationsModule,
    ReportsModule,
    CampaignModule,
    BanksModule,
    NgxUiLoaderModule.forRoot({
      minTime: 1,
      bgsPosition: POSITION.centerCenter,
      bgsType: SPINNER.rectangleBounce,
    }),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: false,
      excludeRegexp: ['v1/time_tracking'],
    }),
    // NgxUiLoaderRouterModule.forRoot({showForeground: false}),
    // Angulartics2Module.forRoot([Angulartics2GoogleAnalytics]),
    AppRoutingModule, // must be imported as the last module as it contains the fallback route
    CodemirrorModule
  ],
  declarations: [AppComponent],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
